"use client";
import React from "react";
import ITRSimulation from "../components/ITRSimulation";
import PaymentPage from "./PaymentPage";
const page = () => {
  return (
    <>
      <ITRSimulation />
      <PaymentPage />
    </>
  );
};

export default page;
